import { Component, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { CreateProfileService } from '../../core/routing/services/profile/create-profile.service';
import { GlobalConstants } from '../../common/constants/global.constant';
import { CommonService } from '../../common/services/common.service';

@Component({
  selector: 'iposcen-account',
  templateUrl: './asset-library.component.html',
  styleUrls: ['./asset-library.component.scss']
})
export class AssetLibraryComponent implements OnInit {
  userId: string = sessionStorage.getItem(GlobalConstants.USER_ID);
  userRole: string = sessionStorage.getItem(GlobalConstants.USER_ROLE);
  retailerId: string = sessionStorage.getItem(GlobalConstants.RETAILER_ID);
  retailerName: string = sessionStorage.getItem(GlobalConstants.RETAILER_NAME);
  sideNav = 'store';
  intelAdmin = GlobalConstants.INTEL_ADMIN;
  retailHQUser: string = GlobalConstants.RETAIL_HQ_USER;
  storeUser: string = GlobalConstants.STORE_USER;
  regionalHQUser: string = GlobalConstants.REGIONALHQ;
  isSrtEnabled: boolean;
  storeLogoLabel = GlobalConstants.STORE_LOGO_LABEL;
  private ngUnsubscribe = new Subject<boolean>();
  isRegionalHQ: boolean = false;
  regionalDisplay = [];
  regionalData: any;
  regionalRetailerIDs: any;
  selectedRegionalData: any;
  regionalMapIDs = {};
  iscustomSrtEnabled: boolean;
  previousUrl: string;
  showRetailGif: boolean;
  isPriceSupress: boolean;
  constructor(
    private createProfileService: CreateProfileService,
    private commonSerivce: CommonService,
  ) { }

  ngOnInit(): void {
    if (this.userRole === this.retailHQUser || this.userRole === this.storeUser || this.userRole === this.regionalHQUser) {
      this.createProfileService.getUserRoleData(this.userId, this.retailerId)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(data => {
          this.isSrtEnabled = data.retailer.srtEnabled;
          this.commonSerivce.setSrtTileEnabled(this.isSrtEnabled);
          const retailerConfig = JSON.parse(data.retailer.configurations);
          this.iscustomSrtEnabled = retailerConfig?.customSrtEnabled ? retailerConfig?.customSrtEnabled : false;
          this.commonSerivce.setCustomTileEnabled(this.iscustomSrtEnabled);
          this.commonSerivce.isSizeContraintsEnabled = retailerConfig?.removeEnabled ? retailerConfig?.removeEnabled : false;
          this.isPriceSupress = retailerConfig?.isPriceSupress ? retailerConfig?.isPriceSupress : false;
        })
    }
    // For RegionalHQ Asset Library page
    if(this.userRole === this.regionalHQUser){
      this.isRegionalHQ = true;
     }  
    this.selectedRegionalData =sessionStorage.getItem('retailerName');
    this.commonSerivce.getRegionalUserDetails
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(data => {
        this.regionalData = data;
        if (this.regionalData) {
          this.regionalDisplay = this.regionalData['retailerName']?.split(",");
          this.regionalRetailerIDs = this.regionalData['retailerID']?.split(",");
        }
      });
      this.commonSerivce.getRetailGifValue
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(data => {
          this.showRetailGif = data;
      });
  }

  setSideNav(value: string) {
    this.sideNav = value;
    if (this.sideNav === 'attractor') this.commonSerivce.isFromAttractLoop = true; 
    else this.commonSerivce.isFromAttractLoop = false;
    // IIT2-9196 -start
    if (this.sideNav === GlobalConstants.BANNER) this.commonSerivce.isBannerCarousel = true; 
    else this.commonSerivce.isBannerCarousel = false;
    // IIT2-9196 -end
    window.scroll(0,0);
    this.showRetailGif = false;
    this.commonSerivce.setSwitchstatus(false);
  }
  selectRegionalList(data) {

    this.selectedRegionalData = data;
    this.regionalDisplay.forEach((e, i) => {
      this.regionalMapIDs[e] = this.regionalRetailerIDs[i]
    });
    sessionStorage.setItem('retailerId', this.regionalMapIDs[data]);
    sessionStorage.setItem('retailerName', data);

  }
}
